import { Goal, ID, LifeArea } from '@griply/types';

import { getInheritedLifeAreaIds } from '../derived-goal-state';

export type FilterLocalizedLifeAreasOptions = {
  goals: Goal[];
  showEmptyLifeAreas: boolean;
  // Must be the UNFILTERED set — a sub-goal's life area lives on an ancestor a filtered array has dropped.
  allGoals: Goal[];
};

export const filterLocalizedLifeAreas = (
  lifeAreas: LifeArea[],
  { goals, showEmptyLifeAreas, allGoals }: FilterLocalizedLifeAreasOptions,
): LifeArea[] => {
  if (showEmptyLifeAreas) {
    return lifeAreas.filter(({ archivedAt }) => !archivedAt);
  }

  const goalIds = new Set(goals.map(({ id }) => id));
  const lifeAreaIds = getInheritedLifeAreaIds(allGoals);

  const filledIds = goals.reduce<Set<ID>>((acc, goal) => {
    if (goal.parentIds?.some((parentId) => goalIds.has(parentId))) {
      return acc;
    }
    const lifeAreaId = lifeAreaIds.get(goal.id);
    if (lifeAreaId) {
      acc.add(lifeAreaId);
    }
    return acc;
  }, new Set<ID>());

  return lifeAreas.filter(
    ({ id, archivedAt }) => !archivedAt && filledIds.has(id),
  );
};
